import React from 'react';
import { StyledWrapper } from './ResetPositionChoose.styled';
import IconButton from '@material-ui/core/IconButton';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';

const ResetPositionChoose = (props) => {
  const { setStartMarkerPosition, setEndMarkerPosition } = props;
  return (
    <StyledWrapper
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <IconButton
        onClick={() => {
          setStartMarkerPosition({});
          setEndMarkerPosition({});
        }}
      >
        <SettingsBackupRestoreIcon />
      </IconButton>
    </StyledWrapper>
  );
};

export default ResetPositionChoose;
